import { AllowedFileTypes } from '../types/FileUpload';

export const imageArray: AllowedFileTypes[] = [AllowedFileTypes.JPG, AllowedFileTypes.JPEG, AllowedFileTypes.PNG];
